import { useScreenSize } from '@/hooks';
import type { SVGProps } from 'react';

type Props = Omit<SVGProps<SVGSVGElement>, 'width' | 'height'> & {
    width?: number;
    height?: number;
    fill?: string;
};

export const ElevatorIcon = ({ width = 40, height = 40, fill = 'currentColor', ...props }: Props) => {
    const { scaleWidthPixel, scaleHeightPixel } = useScreenSize();
    return (
        <svg width={scaleWidthPixel(width)} height={scaleHeightPixel(height)} viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path
                d="M20.3157 14H24.9999C25.5522 14 25.9999 14.4477 25.9999 15V24.3684C25.9999 24.9207 25.5522 25.3684 24.9999 25.3684H20.3157V14Z"
                fill={fill}
            />
            <path d="M14 15C14 14.4477 14.4477 14 15 14H19.6842V25.3684H15C14.4477 25.3684 14 24.9207 14 24.3684V15Z" fill={fill} />
            <path d="M16.8424 18.752L15.3716 20.6135H18.3132L16.8424 18.752Z" fill="white" />
            <path d="M23.0496 20.6135L24.5204 18.752H21.5789L23.0496 20.6135Z" fill="white" />
        </svg>
    );
};
